import type { ReactNode } from "react";
import { cn } from "@shared/lib/utils";

interface OverviewPageProps {
  title: string;
  mainActions?: ReactNode;
  viewToggle?: ReactNode;
  filterBar?: ReactNode;
  content: ReactNode;
  className?: string;
}

export function OverviewPage({
  title,
  mainActions,
  viewToggle,
  filterBar,
  content,
  className,
}: OverviewPageProps) {
  return (
    <div className={cn("flex h-full flex-col", className)}>
      {/* Header Section */}
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-3xl font-bold">{title}</h1>
        {mainActions && (
          <div className="flex items-center gap-2">{mainActions}</div>
        )}
      </div>

      {/* View Toggle Bar */}
      {viewToggle && (
        <div className="mb-4 flex items-center justify-end">{viewToggle}</div>
      )}

      {/* Filter Bar */}
      {filterBar && (
        <div className="mb-6 rounded-lg border border-border bg-card p-4">
          {filterBar}
        </div>
      )}

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto">{content}</div>
    </div>
  );
}
